import React, {useEffect, useState} from "react";
import NarrativesItem from "./NarrativesItem";
import classNames from "classnames";
import {settings} from "../../constants/carousel-settings";
import {usePanel} from "../../redux/reducer/panel";
import {useModal} from "../../hooks/useModal";
import AppearSensor from "../baseComponents/helpers/appearSensor/AppearSensor";
import dynamic from "next/dynamic";
const Carousel = dynamic(() => import('../baseComponents/gui/carousel/Carousel'), {ssr: false});
import styles from "./Narratives.module.scss";



const Narratives = React.forwardRef(
  function Narratives({list,className}, ref) {
    const [status, setStatus] = useState("start");
    const {activeStoryId} = usePanel();
    const {addModal}=useModal();

    useEffect(()=>{
      if (activeStoryId !== null){
        addModal({
          type: "narrativesModal",
          props: {
            ...list[activeStoryId],
            allList:list.length
          }
        });
      }
    },[activeStoryId]);


    return (
      <section className={classNames(styles.narratives, className, {
        [styles[`narratives_${status}`]]:status,
      })} ref={ref}>
          <div className={classNames(styles.narratives__content)}>
            <Carousel itemsData={list}
                      item={NarrativesItem}
                      settings={{
                        ...settings.narrativesSetting,
                        onReachEnd:()=>{
                          setStatus("end")
                        },
                        onReachBeginning:()=>{
                          setStatus("start")
                        },
                        onSlideChange:({isBeginning, isEnd})=>{
                          if (!isBeginning && !isEnd){
                            setStatus("")
                          }
                        }
                      }}
            />
          </div>

      </section>
    );
  });
export default Narratives;
Narratives.propTypes = {};

